__turbopack_context__.v({
  "content": "AccordionMenu-module-scss-module__0xI1Oq__content",
  "content_open": "AccordionMenu-module-scss-module__0xI1Oq__content_open",
  "icon": "AccordionMenu-module-scss-module__0xI1Oq__icon",
  "icon_open": "AccordionMenu-module-scss-module__0xI1Oq__icon_open",
  "innerContent": "AccordionMenu-module-scss-module__0xI1Oq__innerContent",
  "main": "AccordionMenu-module-scss-module__0xI1Oq__main",
  "mainText": "AccordionMenu-module-scss-module__0xI1Oq__mainText",
  "title": "AccordionMenu-module-scss-module__0xI1Oq__title",
  "wrapper": "AccordionMenu-module-scss-module__0xI1Oq__wrapper",
});
